import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
	palette: {
		type: 'light',
		primary: {
			main: '#00a1df',
			contrastText: '#ffffff',
		},
		secondary: {
			main: '#f36f16',
			contrastText: '#ffffff',
		},
		success: {
			main: '#0dbf7b',
			contrastText: '#ffffff',
		},
		warning: {
			main: '#FFBE0B',
			contrastText: '#ffffff',
		},
		error: {
			main: '#e72731',
		},
		info: {
			main: '#7f56c5',
		},
		appbar: {
			main: '#F0F9F9',
			contrastText: '#4C4F50'
		}
	},
});